import { render, staticRenderFns } from "./dialogForm.vue?vue&type=template&id=2df98267"
import script from "./dialogForm.vue?vue&type=script&lang=js"
export * from "./dialogForm.vue?vue&type=script&lang=js"
import style0 from "./dialogForm.vue?vue&type=style&index=0&id=2df98267&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports